import { Icon } from "@/components/Icon/Icon";
import type { OauthOnlyState, SignInPending } from "../useSignInFlow";
import { OAuthProviderButton, providerLabel } from "./OAuthProviderButton";

function joinProviders(names: string[]): string {
  if (names.length <= 1) return names[0] ?? "";
  if (names.length === 2) return `${names[0]} or ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, or ${names[names.length - 1]}`;
}

type Props = {
  state: OauthOnlyState;
  email: string;
  onContinue: (provider: string) => void;
  pending: SignInPending;
  disabled?: boolean;
};

export function OAuthMethodBanner({
  state,
  email,
  onContinue,
  pending,
  disabled,
}: Props) {
  const names = state.providers.map(providerLabel);

  return (
    <div className="signin-method-banner">
      <div className="signin-method-banner-text">
        <Icon name="info" size={13} />
        <span>
          Your account{" "}
          <span className="signin-method-banner-email">{email}</span> signs in
          with <strong>{joinProviders(names)}</strong>. Use the button below to
          continue.
        </span>
      </div>
      <div className="signin-method-banner-buttons">
        {state.providers.map((p) => (
          <OAuthProviderButton
            key={p}
            provider={p}
            onClick={() => onContinue(p)}
            pending={pending}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  );
}
